module.exports = __webpack_public_path__ + "static/media/438203935_896062455654165_4449360487045369452_n.65a47cb1.jpg";